import { render, staticRenderFns } from "./CustomizeMetalE.vue?vue&type=template&id=3694b227&scoped=true"
import script from "./CustomizeMetalE.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalE.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalE.vue?vue&type=style&index=0&id=3694b227&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3694b227",
  null
  
)

export default component.exports